import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Sparkles } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Why Us", id: "why" },
  { label: "Portfolio", id: "portfolio" },
  { label: "Live Demo", id: "live-demo" },
  { label: "Process", id: "process" },
  { label: "Blog", id: "blog" },
  { label: "FAQ", id: "faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50"
      data-testid="navbar"
    >
      <div className={`mx-auto max-w-7xl mt-3 px-4 sm:px-6 transition-[padding] duration-300`}>
        <div className={`flex items-center justify-between rounded-full px-4 sm:px-6 py-3 ${scrolled ? "glass-strong" : "bg-transparent"}`}>
          <button onClick={() => go("hero")} className="flex items-center gap-2" data-testid="nav-logo">
            <span className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-[#00E5FF] to-[#7B61FF]">
              <Sparkles className="h-4 w-4 text-[#0B1220]" />
            </span>
            <span className="font-display text-lg font-bold tracking-tight">9noc<span className="text-gradient">AI</span></span>
          </button>

          <nav className="hidden lg:flex items-center gap-7">
            {LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                data-testid={`nav-${l.id}`}
                className="text-sm text-white/70 hover:text-white transition-colors"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={() => go("contact")}
              data-testid="nav-cta"
              className="hidden sm:inline-flex items-center rounded-full bg-white text-[#0B1220] px-5 py-2 text-sm font-semibold hover:bg-[#00E5FF] transition-colors"
            >
              Book Consultation
            </button>
            <button className="lg:hidden text-white" onClick={() => setOpen((v) => !v)} data-testid="nav-toggle">
              {open ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden mx-4 mt-2 glass-strong rounded-2xl overflow-hidden"
          >
            <div className="flex flex-col p-4">
              {LINKS.map((l) => (
                <button key={l.id} onClick={() => go(l.id)} className="py-3 text-left text-white/80" data-testid={`nav-m-${l.id}`}>
                  {l.label}
                </button>
              ))}
              <button onClick={() => go("contact")} className="mt-2 rounded-full bg-[#00E5FF] text-[#0B1220] py-3 font-semibold">
                Book Consultation
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
